// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__37At9","large":"styles_large__MsxWd"};